// extracted by mini-css-extract-plugin
export default {"homeM":"Nf7evY1F4RmzmD9VB51x"};